import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { QUERY_KEY } from './useFilesList.query';

export const useFileDuplicationProcessQuery = (fileId: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isLoading } = useMutation(
    () => api.patch(API_URL.FILE_PROCESS_DUPLICATE_BY_FILE_ID(fileId), undefined),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
    }
  );
  const handleProcess = useCallback(async () => {
    await mutateAsync();
  }, [mutateAsync]);

  return {
    handleProcess,
    isSuccess,
    isLoading,
  };
};

export default useFileDuplicationProcessQuery;
